import axios from "axios"

const initializeApp = () => {
    // Access tokens are now kept in Redux memory and renewed with the
    // HttpOnly refresh-token cookie. Remove tokens left by older releases.
    // This is intentionally idempotent so every returning student is migrated
    // automatically the first time they load the updated application.
    localStorage.removeItem("token")
    
    // Setting base URL for all API request via axios
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL


    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        // dev code



    } else {
        // Prod build code



        // Removing console.log from prod
        console.log = () => {};


        // init analytics here
    }

}

export default initializeApp
